enum PersonVoteOption {
  Yes = 'yes',
  No = 'no',
  Other = 'other',
}

export default PersonVoteOption;
